import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { filter, Subject, take } from "rxjs";

import { AuthService } from "~core/services/auth.service";
import { UserType } from "~shared/enums/user.enum";

@Directive({
	selector: '[appUserType]',
})
export class UserTypeDirective implements OnInit, OnDestroy {
	@Input() appUserType: UserType;
	@Input() appUserTypeAnd: boolean = true;

	private directiveDestroyed$: Subject<boolean> = new Subject();

	constructor(
		private readonly templateRef: TemplateRef<unknown>,
        private readonly viewContainer: ViewContainerRef,
		private readonly authService: AuthService
	) {}

	public ngOnInit(): void {
		this.viewContainer.clear();

		this.authService.currentUser$
			.pipe(
				filter((user) => !!user),
				take(1)
			)
			.subscribe((user) => {
				this.viewContainer.clear();

				if (this.appUserType === user?.userType && this.appUserTypeAnd) {
					return this.viewContainer.createEmbeddedView(this.templateRef);
				}

				this.viewContainer.clear();
			})
	}

	public ngOnDestroy(): void {
		this.directiveDestroyed$.next(true);
		this.directiveDestroyed$.complete()
	}
}
